export default __webpack_public_path__ + "static/media/EN_15.2db508c5.svg";